import React, {Component, PropTypes} from 'react'
import moment from 'moment'
import {Row, Col} from 'react-bootstrap'
import extract from '../../core/extract'
import Card from '../../core/components/Card'
import Icon from '../../core/components/Icon'
import {TicketClaim} from '../models'
import i18n from '../i18n'
import style from './TicketClaimCard.less'

function levelToStatus(level) {
    if (level == 0) return 'success'
    if (level == 1) return 'warning'
    if (level >= 2) return 'danger'
    return 'success'
}

class TicketClaimCard extends Component {
    static propTypes = {
        ticketClaim: PropTypes.object.isRequired
    }

    constructor(props) {
        super(props)

        this.state = {
        }
    }

    componentWillMount() {
        const {ticketClaim} = this.props

        const priority = TicketClaim.findPriority(ticketClaim)
        this.setState({priority})
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.ticketClaim != this.props.ticketClaim) {
            const {ticketClaim} = nextProps

            const priority = TicketClaim.findPriority(ticketClaim)
            this.setState({priority})
        }
    }

    render() {
        const {ticketClaim, ...others} = this.props
        const {priority} = this.state

        const status = levelToStatus(priority && priority.level)

        const header = (
            <h5>{i18n.ticketClaim} <small>n° {ticketClaim.ref || ticketClaim.uid}</small></h5>
        )

        const help = (
            <div>
                <Icon icon='clock' size='xs' />
                <span>{moment(ticketClaim.openedAt).format(i18n.openedDateTimeFormat)}</span>
            </div>
        )

        const addon = (
            <Icon icon={'status-' + status} size='xs' />
        )

        return (
            <div className={style.default}>
                <Card
                    kind='tab'
                    status={status}
                    header={header}
                    addon={addon}
                    help={help}
                    {...others}>
                    <Row className='no-gutter'>
                        <Col sm={6}>
                            <div className={style.ticket}>
                                <h5>> {i18n.ticket} n° <small>{ticketClaim.ticketReference.ref || ticketClaim.ticketReference.uid}</small></h5>
                            </div>
                        </Col>
                        <Col sm={6}>
                            <div className={style.state}>
                                <h5>> {i18n.state} : <small>{extract(i18n.stateEnum, ticketClaim.state)}</small></h5>
                            </div>
                        </Col>
                    </Row>
                    <Row className='no-gutter'>
                        <Col sm={6}>
                            <div className={style.actor}>
                                <h5>{ticketClaim.openedBy && ticketClaim.openedBy.name}</h5>
                            </div>
                        </Col>
                        <Col sm={6}>
                            {ticketClaim.urgencyLevel && (
                                <div className={style.priority}>
                                    <div className={style.priorityContent}>
                                        <h5>{i18n.urgencyLevel}</h5>
                                        <p>{ticketClaim.urgencyLevel.label}</p>
                                    </div>
                                </div>
                            )}
                            {ticketClaim.ticketClaimQualification && ticketClaim.ticketClaimQualification.treatmentPriority && (
                                <div className={style.priority}>
                                    <div className={style.priorityContent}>
                                        <h5>{i18n.treatmentPriority}</h5>
                                        <p>{ticketClaim.ticketClaimQualification.treatmentPriority.label}</p>
                                    </div>
                                </div>
                            )}
                        </Col>
                    </Row>
                </Card>
            </div>
        )
    }
}

export default TicketClaimCard


// WEBPACK FOOTER //
// ./lib/claim/components/TicketClaimCard.js